/// <amd-module name="Feed/Legacy/Actions/FeedList/PackageManagementSettingsDialogHandler" />
import { ILegacyPlatformService } from "VSS/Legacy/Legacy";
import { IVssPageContext } from "VSS/Platform/Context";

import { CiConstants } from "Feed/Common/Constants/Constants";
import { CustomerIntelligenceHelper } from "Feed/Legacy/Helpers/CustomerIntelligenceHelper";

export class PackageManagementSettingsDialogHandler {
    public static Open = (pageContext: IVssPageContext): void => {
        const legacyPlatformService = pageContext.getService<ILegacyPlatformService>("ILegacyPlatformService");
        legacyPlatformService
            .loadModules(
                ["Package/Scripts/Dialogs/GlobalSettingsDialog"],
                ["ms.feed.package-service-context-data-provider"]
            )
            .then(() => {
                legacyPlatformService
                    .requireModules(["VSS/Controls/Dialogs", "Package/Scripts/Dialogs/GlobalSettingsDialog"])
                    .then(([dialogsModule, globalSettingsDialogModule]) => {
                        dialogsModule.ModalDialogO.show(globalSettingsDialogModule.GlobalSettingsDialog, {});
                        CustomerIntelligenceHelper.publishEvent(pageContext, CiConstants.GlobalSettingsDialogOpened);
                    });
            });
    };
}
